<template>
	<div class="upsell-rules-main">
		<div v-if="dialog">
			<v-dialog
			v-model="dialog"
			content-class="dialog-over-whole-page"
			>
			<v-card>
				<v-card-title class="upsell-title">
					<div class="popup-wrapper">
						<upsell-rules @addToBasketClicked="getAddToBasket" :onCloseDialog="onCloseDialog" />
						<div class="close-btn" @click="closeDialog"></div>
					</div>
				</v-card-title>
			</v-card>
		</v-dialog>
		</div>
	</div>
</template>

<script>
	import UpsellRules from "../../../GlobalSharedComponents/Shop/UpsellRules";

	export default {
		name: "UpsellRules-gt3",
		props: ["displayUpsellModal"],
		data() {
			return {
				dialog: false
			};
		},
		components: {
			UpsellRules
		},
		methods: {
			openDialog() {
				this.dialog = this.displayUpsellModal;
			},
			closeDialog() {
				this.dialog = !this.displayUpsellModal;
			},
			onCloseDialog() {
				this.$emit("closeUpsellModal");
			},
			getAddToBasket(value) {
				this.$emit("addToBasketClicked", value);
			}
		},
		watch: {
			displayUpsellModal(){
				this.dialog = this.displayUpsellModal;
			}
		}
	};
</script>

<style scoped lang="scss">
.product-label-wrapper {
	position: absolute;
}
.list-container{
	padding: 10px 5px;
}
.upsell-rules-main {
	position: relative;
}
.v-dialog__content{
	width: 75%;
}
.button-upsell {
	text-align: right;
	background: #f6f6f6;
	width: 100%;
	position: absolute;
	bottom: -18px;
	float: right;
	color: #0d0109;
	text-decoration: underline;
	cursor: pointer;
	height: 30px;
	padding: 5px 18px 0;
}
</style>
